import { render, staticRenderFns } from "./STela.vue?vue&type=template&id=6b09e644"
import script from "./STela.vue?vue&type=script&lang=js"
export * from "./STela.vue?vue&type=script&lang=js"
import style0 from "./STela.vue?vue&type=style&index=0&id=6b09e644&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports